import React, { useEffect, useState } from "react";
import OneCategory from "./category";
import Banner1 from "../components/Banner1";
import { useFetch } from "../custom/api";
import LoadingPage from "./LoadingPage";



export default function CardList() {
  const { myFetch } = useFetch();
  const [recipes, setRecipes] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const resp = await myFetch('recipes', { method: "GET" })
      const r = await resp.json()
      setRecipes(r);
    };
    fetchData();
  }, []);

  return (
    <>
    {recipes === null ? (
        <LoadingPage />
      ) : (
        <div>
        {recipes.map((recipe) => {
          return (
            <OneCategory
              key = {Math.random()}
              title={recipe.tag_name}
              tagHref={recipe.foods[0].tag_id}
              foods={recipe.foods}
            />
          );
        })}
      </div>
      )}

      

      {/* <Banner1
        title="برنامه پیشنهادی"
        desc="برای یک هفته خیالت راحته! کلیک کن"
        bclass={["banner2-1"]}
        linkTo={["#"]}
      /> */}
    </>
  );
}
